function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "path-1",
  opacity: 1,
  fillRule: "evenodd",
  d: "M45.19807434082031,18.090697420786114 C46.280487060546875,17.869811190317364 47.33702087402344,18.568175448129864 47.55793762207031,19.650633944223614 C47.84977722167969,21.102416170786114 47.99714660644531,22.579527987192364 47.99790954589844,24.060362948129864 C47.99101257324219,33.988951815317364 41.334442138671875,42.682433260629864 31.751235961914062,45.278502596567364 C22.16802978515625,47.874571932504864 12.033599853515625,43.729674471567364 7.01617431640625,35.162169588754864 C1.998748779296875,26.594603670786114 3.3419952392578125,15.728026522348614 10.294647216796875,8.640196932504864 C17.247299194335938,1.552306307504864 28.085968017578125,-8.214013860197156e-7 36.74855041503906,4.851500643442364 C37.714996337890625,5.392699373911114 38.059722900390625,6.614867342661114 37.51850891113281,7.581298006723614 C36.97731018066406,8.547789705942364 35.75511169433594,8.892455233286114 34.788665771484375,8.351256502817364 C27.402236938476562,4.221556795786114 18.136520385742188,5.795104159067364 12.527572631835938,12.131835116098614 C6.9186248779296875,18.468505037973614 6.4814910888671875,27.856749666879864 11.477340698242188,34.687255037973614 C16.473190307617188,41.517699373911114 25.552597045898438,43.945494784067364 33.29081726074219,40.520018709848614 C41.02903747558594,37.094481600473614 45.335906982421875,28.741027010629864 43.638153076171875,20.450560702036114 C43.41725158691406,19.368163241098614 44.11564636230469,18.311583651254864 45.19807434082031,18.090697420786114 L45.99803161621094,6.059813631723614 C46.52882385253906,6.059813631723614 47.03782653808594,6.270812166879864 47.41294860839844,6.646361483286114 C47.788482666015625,7.021483553598614 47.999481201171875,7.530455721567364 47.999481201171875,8.061278475473614 C47.999481201171875,8.592040194223614 47.788482666015625,9.101073397348614 47.41294860839844,9.476195467661114 L27.414108276367188,29.475035799692364 C27.038986206054688,29.850585116098614 26.529983520507812,30.061583651254864 25.999191284179688,30.061583651254864 C25.468399047851562,30.061583651254864 24.959381103515625,29.850585116098614 24.584274291992188,29.475035799692364 L16.584732055664062,21.475463045786114 C15.803298950195312,20.694029940317364 15.803298950195312,19.427123202036114 16.584732055664062,18.645629061411114 C17.366180419921875,17.864195955942364 18.633132934570312,17.864195955942364 19.414566040039062,18.645629061411114 L25.999191284179688,25.230284823129864 L44.58311462402344,6.646361483286114 C44.958221435546875,6.270812166879864 45.46723937988281,6.059813631723614 45.99803161621094,6.059813631723614 L45.19807434082031,18.090697420786114Z"
}), React.createElement("filter", {
  id: "filter-2",
  filterUnits: "userSpaceOnUse",
  x: "-50%",
  y: "-50%",
  width: "200%",
  height: "200%"
}, React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadow-1-feOffset-shadow",
  dx: 0,
  dy: 2
}), React.createElement("feGaussianBlur", {
  in: "shadow-1-feOffset-shadow",
  result: "shadow-1-feGaussianBlur-shadow",
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  in: "shadow-1-feGaussianBlur-shadow",
  result: "shadow-1-feColorMatrix-shadow",
  type: "matrix",
  values: "0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.5 0"
})), React.createElement("filter", {
  id: "filter-3",
  filterUnits: "userSpaceOnUse",
  x: "-50%",
  y: "-50%",
  width: "200%",
  height: "200%"
}, React.createElement("feGaussianBlur", {
  in: "SourceAlpha",
  result: "innershadow-1-feGaussianBlur-innershadow",
  stdDeviation: 1.5
}), React.createElement("feOffset", {
  in: "innershadow-1-feGaussianBlur-innershadow",
  result: "innershadow-1-feOffset-innershadow",
  dx: 0,
  dy: 1
}), React.createElement("feComposite", {
  in: "innershadow-1-feOffset-innershadow",
  in2: "SourceAlpha",
  result: "innershadow-1-feOffset-innershadow",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), React.createElement("feColorMatrix", {
  in: "innershadow-1-feOffset-innershadow",
  result: "innershadow-1-feColorMatrix-innershadow",
  type: "matrix",
  values: "0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.5 0"
})), React.createElement("mask", {
  id: "mask-4",
  maskUnits: "userSpaceOnUse",
  maskContentUnits: "userSpaceOnUse",
  x: 0,
  y: 0
}, React.createElement("rect", {
  opacity: 1,
  x: 0,
  y: 0,
  width: 51.999481201171875,
  height: 52.045775545786114,
  fill: "black"
}), React.createElement("use", {
  xlinkHref: "#path-1",
  fill: "white"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#path-1",
  fill: "black",
  filter: "url(#filter-2)",
  stroke: "black",
  strokeOpacity: 1,
  strokeWidth: 1
}), React.createElement("use", {
  xlinkHref: "#path-1",
  fill: "rgb(106,219,110)",
  fillOpacity: 1,
  id: "line"
}), React.createElement("use", {
  xlinkHref: "#path-1",
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-3)"
}), React.createElement("use", {
  xlinkHref: "#path-1",
  fillOpacity: 0,
  stroke: "rgb(128,128,128)",
  strokeOpacity: 1,
  strokeWidth: 2,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  mask: "url(#mask-4)"
}));

var SvgOk = function SvgOk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: 52.045775545786114,
    width: 51.999481201171875,
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ok.00af49c5.svg";
export { ForwardRef as ReactComponent };